import { render, staticRenderFns } from "./OtherSettingsEditModal.vue?vue&type=template&id=ff2ccf12&scoped=true&"
import script from "./OtherSettingsEditModal.vue?vue&type=script&lang=js&"
export * from "./OtherSettingsEditModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff2ccf12",
  null
  
)

export default component.exports